export default {
  'editorial-staff': 'Onze redactie',
  'published-on': 'Gepubliceerd op',
  'read-articles': 'Lees zijn/haar artikelen',
  'about-author': 'Over de auteur',
}
